import React from 'react';

type CopyrightProps = {
  className?: string;
};

const Copyright: React.FC<CopyrightProps> = ({ className }) => (
  <p className={className}>© {new Date().getFullYear()} Mooveno. Wszystkie prawa zastrzeżone</p>
);

export default Copyright;
